export const photos = [
  {
    alt: 'Trekking',
    src: './photos/IMG_2043.webp',
    original_path: './photos/IMG_2043.jpg',
    tags: ['Landscape', 'Europe'],
    time: [2022, 'July', ''],
    hv: true,
    rating: 9,
  },
  {
    alt: 'Melting Origin',
    src: './photos/IMG_2176.webp',
    original_path: './photos/IMG_2176.jpg',
    tags: ['Landscape', 'Europe'],
    time: [2022, 'July', ''],
    hv: true,
    rating: 8,
  },
  {
    alt: 'A sheep meh like cow',
    src: './photos/IMG_2214.webp',
    original_path: './photos/IMG_2214.jpg',
    tags: ['Animal', 'Europe'],
    time: [2022, 'July', ''],
    hv: false,
    rating: 8,
  },
  {
    alt: 'Oily Green',
    src: './photos/IMG_4493.webp',
    original_path: './photos/IMG_4493.jpg',
    tags: ['Phone', 'Green', 'Plants', 'San Francisco'],
    time: [2022, 'September', '24'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Fog',
    src: './photos/DSC00611.webp',
    original_path: './photos/DSC00611.jpg',
    tags: ['Street', 'Europe', 'B&W'],
    time: [2022, 'July', ''],
    hv: true,
    rating: 5,
  },
  {
    alt: 'Busy Train Station',
    src: './photos/IMG_1786.webp',
    original_path: './photos/IMG_1786.jpg',
    tags: ['Street', 'Europe','Human'],
    time: [2022, 'July', ''],
    hv: true,
    rating: 2,
  },
  {
    alt: 'Man Playing Guitar',
    src: './photos/IMG_1780.webp',
    original_path: './photos/IMG_1780.jpg',
    tags: ['Street', 'San Francisco','Human'],
    time: [2022, '', ''],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Sea Monster in Mall',
    src: './photos/IMG_3334.webp',
    original_path: './photos/IMG_3334.jpg',
    tags: ['Structure', 'Phone', 'Europe', 'B&W'],
    time: [2022, 'July', '27'],
    hv: false,
    rating: 8,
  },
  {
    alt: 'Watching Waterfall',
    src: './photos/IMG_3882.JPG',
    original_path: './photos/IMG_3882.JPG',
    tags: ['Animal', 'Europe', 'Phone'],
    time: [2022, 'Aug', '9'],
    hv: false,
    rating: 1,
  },
  {
    alt: 'Dorm Ceilling',
    src: './photos/IMG_4159.JPG',
    original_path: './photos/IMG_4159.JPG',
    tags: ['Stucture', 'Berkeley', 'Phone'],
    time: [2022, 'Aug', '22'],
    hv: true,
    rating: 3,
  },
  {
    alt: 'Woman in street market',
    src: './photos/IMG_1757.webp',
    original_path: './photos/IMG_1757.jpg',
    tags: ['Street', 'San Francisco','Human'],
    time: [2022, '', ''],
    hv: true,
    rating: 1,
  },
  {
    alt: 'Clock Tower',
    src: './photos/DSC00689.webp',
    original_path: './photos/DSC00689.jpg',
    tags: ['Berkeley'],
    time: [2022, 'September', ''],
    hv: true,
    rating: 3,
  },
  {
    alt: 'Staff Charging',
    src: './photos/IMG_3333.webp',
    original_path: './photos/IMG_3333.jpg',
    tags: ['Phone', 'Structure', 'Europe'],
    time: ['2022', 'July', '27'],
    hv: false,
    rating: 7,
  },
  {
    alt: 'Picking Grocery',
    src: './photos/IMG_1506.webp',
    original_path: './photos/IMG_1506.jpg',
    tags: ['San Francisco', 'Street','Human'],
    time: ['2022', 'May', '30'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'SF City',
    src: './photos/IMG_9906.webp',
    original_path: './photos/IMG_9906.jpg',
    tags: ['Street', 'San Francisco', 'B&W'],
    time: ['2022', 'Jan', '26'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Revolution',
    src: './photos/IMG_7918.webp',
    original_path: './photos/IMG_7918.jpg',
    tags: ['Abstract', 'Purple'],
    time: ['2021', 'Aug', '18'],
    hv: true,
    rating: 5,
  },
  {
    alt: 'Fingerprint',
    src: './photos/IMG_7913.webp',
    original_path: './photos/IMG_7913.jpg',
    tags: ['Purple', 'Abstract'],
    time: ['2021', 'Aug', '19'],
    hv: true,
    rating: 5,
  },
  {
    alt: 'Radiance',
    src: './photos/IMG_9178.webp',
    original_path: './photos/IMG_9178.jpg',
    tags: ['San Francisco','Human'],
    time: ['2021', 'Nov', '27'],
    hv: false,
    rating: 7,
  },
  {
    alt: 'Applause',
    src: './photos/IMG_9063.webp',
    original_path: './photos/IMG_9063.jpg',
    tags: [ 'Human'],
    time: ['2021', 'Oct', '25'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Man with Flower',
    src: './photos/IMG_0690_1.webp',
    original_path: './photos/IMG_0690_1.jpg',
    tags: ['Street', 'Protrait', 'Human'],
    time: ['2022', 'March', '2'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Banquet on Island',
    src: './photos/IMG_0976.webp',
    original_path: './photos/IMG_0976.jpg',
    tags: ['Plants', 'Green', 'San Francisco', 'Landscape'],
    time: ['2022', 'May', '9'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Sinking',
    src: './photos/seashore.webp',
    original_path: './photos/seashore.jpg',
    tags: ['Purple', 'Landscape'],
    time: ['2022', 'April', '25'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Trapped when Falling',
    src: './photos/bigger.webp',
    original_path: './photos/bigger.jpg',
    tags: ['Purple', 'Plants'],
    time: ['2021', 'June', '4'],
    hv: true,
    rating: 5,
  },
  {
    alt: 'Sandwich',
    src: './photos/IMG_0857.jpg',
    original_path: './photos/IMG_0857.webp',
    tags: ['San Francisco', 'Street'],
    time: ['2022', 'May', '4'],
    hv: false,
    rating: 7,
  },
  {
    alt: 'Buy this!',
    src: './photos/IMG_1378.jpg',
    original_path: './photos/IMG_1378.webp',
    tags: ['Street', 'Human'],
    time: ['2022', 'May', '28'],
    hv: true,
    rating: 6,
  },
  {
    alt: 'a Mix of Building',
    src: './photos/buildings.webp',
    original_path: './photos/buildings.jpg',
    tags: ['Abstract', 'San Francisco'],
    time: ['2022', 'April', '14'],
    hv: false,
    rating: 8,
  },
  {
    alt: 'Plant Shop',
    src: './photos/IMG_0761.webp',
    original_path: './photos/IMG_0761.jpg',
    tags: ['Plants', 'San Francisco'],
    time: ['2022', 'March', '10'],
    hv: false,
    rating: 7,
  },
  {
    alt: 'Clipped Star',
    src: './photos/IMG_8912.webp',
    original_path: './photos/IMG_8912.jpg',
    tags: ['Abstract'],
    time: ['2021', 'Oct', '14'],
    hv: false,
    rating: 6,
  },
  {
    alt: 'Tree Camouflage',
    src: './photos/IMG_8860_1.webp',
    original_path: './photos/IMG_8860_1.jpg',
    tags: ['B&W', 'Human'],
    time: ['2021', 'Oct', '13'],
    hv: false,
    rating: 7,
  },
  {
    alt: 'Mystery Awaits',
    src: './photos/IMG_9076-1-1-1.webp',
    original_path: './photos/IMG_9076-1-1-1.jpg',
    tags: ['Abstract', 'Human'],
    time: ['2021', 'Dec', '10'],
    hv: false,
    rating: 8,
  },
  {
    alt: 'Striped',
    src: './photos/IMG_7821-1.webp',
    original_path: './photos/IMG_7821-1.jpg',
    tags: ['Street', 'Human', 'San Francisco'],
    time: ['2021', 'Dec', '10'],
    hv: true,
    rating: 9,
  },
  {
    alt: 'Wandering Joy',
    src: './photos/DSC00292-1-1-1.webp',
    original_path: './photos/DSC00292-1-1-1.jpg',
    tags: ['Street', 'Human'],
    time: ['2021', 'Dec', '10'],
    hv: true,
    rating: 9,
  },
  {
    alt: 'Waiting for Red Light',
    src: './photos/IMG_7762.webp',
    original_path: './photos/IMG_7762.jpg',
    tags: ['Human', 'Street', 'San Francisco'],
    time: ['2021', 'Oct', '14'],
    hv: false,
    rating: 9,
  },
  {
    alt: 'Untitled',
    src: './photos/IMG_9047_1.webp',
    original_path: './photos/IMG_9047_1.jpg',
    tags: ['B&W', 'Human'],
    time: ['2021', 'Oct', '26'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Delicious Place',
    src: './photos/IMG_9849.webp',
    original_path: './photos/IMG_9849.jpg',
    tags: ['Protrait', 'San Francisco', 'Street', 'Human'],
    time: ['2022', 'Jan', '27'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'China Town and Flying Books',
    src: './photos/IMG_9834.webp',
    original_path: './photos/IMG_9834.jpg',
    tags: ['B&W', 'San Francisco', 'Street'],
    time: ['2022', 'Jan', '27'],
    hv: false,
    rating: 8,
  },
  {
    alt: 'Food',
    src: './photos/DSC00298.webp',
    original_path: './photos/DSC00298.JPG',
    tags: ['Food'],
    time: ['2021', 'Dec', '18'],
    hv: true,
    rating: 7,
  },
  {
    alt: '(-_-)zzz',
    src: './photos/IMG_1388.webp',
    original_path: './photos/IMG_1388.jpg',
    tags: ['Animal'],
    time: ['2022', 'May', '30'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Look Better Than Taste',
    src: './photos/IMG_1316.webp',
    original_path: './photos/IMG_1316.jpg',
    tags: ['Food'],
    time: ['2022', 'May', '27'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Mirror Sunset',
    src: './photos/DSC00384.webp',
    original_path: './photos/DSC00384.jpg',
    tags: ['Landscape', 'Biege'],
    time: ['2022', 'Feb', '12'],
    hv: true,
    rating: 9,
  },
  
  {
    alt: 'Little Bird',
    src: './photos/IMG_2282.webp',
    original_path: './photos/IMG_2282.jpg',
    tags: ['Green', 'Europe', 'Animal'],
    time: ['2022', 'Aug', '5'],
    hv: true,
    rating: 9,
  },
  {
    alt: 'Sharpness',
    src: './photos/IMG_2302.webp',
    original_path: './photos/IMG_2302.jpg',
    tags: ['Green', 'Landscape', 'Europe'],
    time: ['2022', 'Aug', '5'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Dream River',
    src: './photos/IMG_2319.webp',
    original_path: './photos/IMG_2319.jpg',
    tags: ['Green', 'Landscape', 'Europe'],
    time: ['2022', 'Aug', '5'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Let Me Get Outta Here',
    src: './photos/IMG_2348.webp',
    original_path: './photos/IMG_2348.jpg',
    tags: ['Animal', 'Green', 'Europe'],
    time: ['2022', 'Aug', '5'],
    hv: true,
    rating: 7,
  },
  {
    alt: "Where's My Food",
    src: './photos/IMG_2370.webp',
    original_path: './photos/IMG_2370.jpg',
    tags: ['Animal', 'Europe', 'Yellow'],
    time: ['2022', 'Aug', '5'],
    hv: true,
    rating: 9,
  },
  {
    alt: 'Deep Inside',
    src: './photos/IMG_2376_1.webp',
    original_path: './photos/IMG_2376_1.jpg',
    tags: ['Green', 'Landscape', 'Europe'],
    time: ['2022', 'Aug', '5'],
    hv: true,
    rating: 6,
  },
  {
    alt: 'Somewhere in Some Movies',
    src: './photos/IMG_2387.webp',
    original_path: './photos/IMG_2387.jpg',
    tags: ['Green', 'Landscape', 'Europe'],
    time: ['2022', 'Aug', '5'],
    hv: true,
    rating: 5,
  },
  {
    alt: 'Untitled',
    src: './photos/IMG_2393_1.webp',
    original_path: './photos/IMG_2393_1.jpg',
    tags: ['Shape of Light', 'Green', 'Europe', 'Landscape', 'Plants'],
    time: ['2022', 'Aug', '6'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Untitled',
    src: './photos/IMG_2394.webp',
    original_path: './photos/IMG_2394.jpg',
    tags: ['Shape of Light', 'Plants', 'Europe'],
    time: ['2022', 'Aug', '6'],
    hv: false,
    rating: 6,
  },
  {
    alt: 'Untitled',
    src: './photos/IMG_2396.webp',
    original_path: './photos/IMG_2396.jpg',
    tags: ['Shape of Light', 'Plants', 'Europe'],
    time: ['2022', 'Aug', '6'],
    hv: true,
    rating: 6.5,
  },
  {
    alt: 'Diamond Swan',
    src: './photos/IMG_2426.webp',
    original_path: './photos/IMG_2426.jpg',
    tags: ['Europe', 'Animal'],
    time: ['2022', 'Aug', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Let Me See',
    src: './photos/IMG_2296.webp',
    original_path: './photos/IMG_2296.jpg',
    tags: ['Animal', 'Europe'],
    time: ['2022', 'Aug', '5'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Untitled',
    src: './photos/IMG_2400_1.webp',
    original_path: './photos/IMG_2400_1.jpg',
    tags: ['Shape of Light', 'Plants', 'Europe'],
    time: ['2022', 'Aug', '6'],
    hv: true,
    rating: 6.5,
  },
  {
    alt: 'Plant saying hi',
    src: './photos/IMG_3227.webp',
    original_path: './photos/IMG_3227.jpg',
    tags: ['Berkeley', 'Plants', 'Green','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: false,
    rating: 7,
  },
  {
    alt: 'Egg Flower',
    src: './photos/IMG_3237.webp',
    original_path: './photos/IMG_3237.jpg',
    tags: ['Plants', 'Berkeley', 'Yellow','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: false,
    rating: 9.5,
  },
  {
    alt: 'Orchid Robot',
    src: './photos/IMG_3240.webp',
    original_path: './photos/IMG_3240.jpg',
    tags: ['Plants', 'Berkeley', 'Yellow','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: true,
    rating: 7.5,
  },
  {
    alt: 'Plant Jelly',
    src: './photos/IMG_3242.webp',
    original_path: './photos/IMG_3242.jpg',
    tags: ['Plants', 'Berkeley','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Green Octopus',
    src: './photos/IMG_3250.webp',
    original_path: './photos/IMG_3250.jpg',
    tags: ['Plants', 'Berkeley', 'Yellow','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: true,
    rating: 8.5,
  },
  {
    alt: 'White Alive Flower on Dead Yellow Flower',
    src: './photos/IMG_3279.webp',
    original_path: './photos/IMG_3279.jpg',
    tags: ['Plants', 'Berkeley', 'Yellow','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: true,
    rating: 7.5,
  },
  {
    alt: 'A Bowl of Rice Flower',
    src: './photos/IMG_3291_1.webp',
    original_path: './photos/IMG_3291_1.jpg',
    tags: ['Plants', 'Berkeley', 'White','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: true,
    rating: 8.5,
  },
  {
    alt: 'Japanese Pool',
    src: './photos/IMG_3310_3.webp',
    original_path: './photos/IMG_3310_3.jpg',
    tags: ['Landscape', 'Berkeley','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: true,
    rating: 9,
  },
  {
    alt: 'Forest',
    src: './photos/IMG_3328.webp',
    original_path: './photos/IMG_3328.jpg',
    tags: ['Landscape', 'Green', 'Berkeley','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Water',
    src: './photos/IMG_3342.webp',
    original_path: './photos/IMG_3342.jpg',
    tags: ['Berkeley','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Flower on Top of Water Fall',
    src: './photos/IMG_3383.webp',
    original_path: './photos/IMG_3383.jpg',
    tags: ['Landscape', 'Green', 'Plants','Berkeley','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: false,
    rating: 9.8,
  },
  {
    alt: 'Rose',
    src: './photos/IMG_3421_1.webp',
    original_path: './photos/IMG_3421_1.jpg',
    tags: ['Pink', 'Plants','Berkeley','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: true,
    rating: 6.5,
  },
  {
    alt: 'Flower and its Image',
    src: './photos/IMG_3432.webp',
    original_path: './photos/IMG_3432.jpg',
    tags: ['Plants','Berkeley','Berkeley Botanical Garden'],
    time: ['2023', 'May', '11'],
    hv: false,
    rating: 9.9,
  },
  {
    alt: 'Overexposure',
    src: './photos/IMG_2513_2.webp',
    original_path: './photos/IMG_2513_2.jpg',
    tags: ['Green', 'Europe', 'Plants'],
    time: ['2022', 'Aug', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Triangle 浮萍',
    src: './photos/IMG_2514.webp',
    original_path: './photos/IMG_2514.jpg',
    tags: ['Green', 'Europe', 'Plants'],
    time: ['2022', 'Aug', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Underwater Cabbage',
    src: './photos/IMG_2515.webp',
    original_path: './photos/IMG_2515.jpg',
    tags: ['Green', 'Europe', 'Plants'],
    time: ['2022', 'Aug', '6'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Berkeley Campanile',
    src: './photos/IMG_2865.webp',
    original_path: './photos/IMG_2865.jpg',
    tags: ['Landscape', 'Rainbow', 'Berkeley'],
    time: ['2023', 'Feb', '19'],
    hv: true,
    rating: 9.9,
  },
  {
    alt: 'Berkeley Campanile',
    src: './photos/IMG_2867.webp',
    original_path: './photos/IMG_2867.jpg',
    tags: ['Rainbow', 'Landscape', 'Berkeley'],
    time: ['2023', 'Feb', '19'],
    hv: true,
    rating: 9.5,
  },
  {
    alt: 'Foothill Guardian',
    src: './photos/IMG_3004_1.webp',
    original_path: './photos/IMG_3004_1.jpg',
    tags: ['Animal', 'Berkeley'],
    time: ['2023', 'Mar', '24'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Sunlight on Campanile Top',
    src: './photos/IMG_2993.webp',
    original_path: './photos/IMG_2993.jpg',
    tags: ['Landscape', 'Berkeley'],
    time: ['2023', 'Mar', '24'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Foothill Guardian',
    src: './photos/IMG_3011.webp',
    original_path: './photos/IMG_3011.jpg',
    tags: ['Animal', 'Berkeley'],
    time: ['2023', 'Mar', '24'],
    hv: true,
    rating: 7.5,
  },
  {
    alt: 'Berkeley Campanile',
    src: './photos/IMG_2600_1.webp',
    original_path: './photos/IMG_2600_1.jpg',
    tags: ['Landscape', 'Berkeley'],
    time: ['2022', 'Dec', '17'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Huntun',
    src: './photos/DSC01015.webp',
    original_path: './photos/DSC01015.jpg',
    tags: ['Food', 'Home'],
    time: ['2023', 'Jan', '22'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Huntun',
    src: './photos/DSC01012.webp',
    original_path: './photos/DSC01012.jpg',
    tags: ['Food', 'Home'],
    time: ['2023', 'Jan', '22'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Sky"s Blue Slide',
    src: './photos/DSC00714.webp',
    original_path: './photos/DSC00714.jpg',
    tags: ['Berkeley', 'Blue'],
    time: ['2022', 'Sep', '19'],
    hv: false,
    rating: 6.5,
  },
  {
    alt: 'Night NYC',
    src: './photos/IMG_4338.webp',
    original_path: './photos/IMG_4338.jpg',
    tags: ['New York', 'Street'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 1',
    src: './photos/IMG_4309.webp',
    original_path: './photos/IMG_4309.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 2',
    src: './photos/IMG_4308.webp',
    original_path: './photos/IMG_4308.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 3',
    src: './photos/IMG_4297.webp',
    original_path: './photos/IMG_4297.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 4',
    src: './photos/IMG_4296.webp',
    original_path: './photos/IMG_4296.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 5',
    src: './photos/IMG_4292.webp',
    original_path: './photos/IMG_4292.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 6',
    src: './photos/IMG_4289.webp',
    original_path: './photos/IMG_4289.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 7',
    src: './photos/IMG_4287.webp',
    original_path: './photos/IMG_4287.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 8',
    src: './photos/IMG_4280.webp',
    original_path: './photos/IMG_4280.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 9',
    src: './photos/IMG_4279.webp',
    original_path: './photos/IMG_4279.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 10',
    src: './photos/IMG_4276.webp',
    original_path: './photos/IMG_4276.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 11',
    src: './photos/IMG_4275.webp',
    original_path: './photos/IMG_4275.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 12',
    src: './photos/IMG_4274.webp',
    original_path: './photos/IMG_4274.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 13',
    src: './photos/IMG_4278_1.webp',
    original_path: './photos/IMG_4278_1.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Firework 14',
    src: './photos/IMG_4228.webp',
    original_path: './photos/IMG_4228.jpg',
    tags: ['New York', 'July 4th'],
    time: ['2023', 'July', '6'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Ducks',
    src: './photos/IMG_4640_1.webp',
    original_path: './photos/IMG_4640_1.jpg',
    tags: ['B&W', 'Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 7.5,
  },
  {
    alt: 'Rainbow Duck',
    src: './photos/IMG_4657.webp',
    original_path: './photos/IMG_4657.jpg',
    tags: ['Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 7.5,
  },
  {
    alt: 'Mud Sweep Sweep Bird',
    src: './photos/IMG_4678.webp',
    original_path: './photos/IMG_4678.jpg',
    tags: ['Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 7,
  },
  {
    alt: 'Fly 1.1',
    src: './photos/IMG_4684_1.webp',
    original_path: './photos/IMG_4684_1.jpg',
    tags: ['B&W', 'Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Fly 1.1',
    src: './photos/IMG_4737.webp',
    original_path: './photos/IMG_4737.jpg',
    tags: ['B&W', 'Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 8.444,
  },
  {
    alt: 'Fly 1.2',
    src: './photos/IMG_4740.webp',
    original_path: './photos/IMG_4740.jpg',
    tags: ['B&W', 'Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 8.444,
  },
  {
    alt: 'Fly 1.3',
    src: './photos/IMG_4742.webp',
    original_path: './photos/IMG_4742.jpg',
    tags: ['B&W', 'Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 8.444,
  },
  {
    alt: 'Fly 5',
    src: './photos/IMG_4685.webp',
    original_path: './photos/IMG_4685.jpg',
    tags: ["B&W", "Animal", "Shenzhen", "Birds of Shenzhen Bay"],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Fly 6',
    src: './photos/IMG_4686.webp',
    original_path: './photos/IMG_4686.jpg',
    tags: ['B&W', 'Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 8,
  },
  {
    alt: 'Spread',
    src: './photos/IMG_4761-Enhanced-NR.webp',
    original_path: './photos/IMG_4761-Enhanced-NR.jpg',
    tags: ['B&W', 'Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 9,
  },
  {
    alt: 'Ballet',
    src: './photos/IMG_4772.webp',
    original_path: './photos/IMG_4772.jpg',
    tags: ['Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 8.5,
  },
  {
    alt: 'Facing the Sea',
    src: './photos/IMG_4771_1.webp',
    original_path: './photos/IMG_4771_1.jpg',
    tags: ['Animal', 'Shenzhen', 'Birds of Shenzhen Bay'],
    time: ['2024', 'Jan', '13'],
    hv: true,
    rating: 8.5,
  },
  {
    alt: 'april cherry blossom',
    src: './photos/DSC01786.webp',
    original_path: './photos/DSC01786.jpg',
    tags: ['Commission Portfolio'],
    time: ['2025', 'Apr', '10'],
    hv: false,
    rating: -1,
  },
  {
    alt: 'april cherry blossom 2',
    src: './photos/DSC01813_1.webp',
    original_path: './photos/DSC01813_1.jpg',
    tags: ['Commission Portfolio'],
    time: ['2025', 'Apr', '10'],
    hv: false,
    rating: -1,
  },
  {
    alt: 'berkeley grad 2',
    src: './photos/DSC01879.webp',
    original_path: './photos/DSC01879.jpg',
    tags: [],
    time: ['2025', 'Apr', '10'],
    hv: true,
    rating: -1,
  },
  {
    alt: 'prom',
    src: './photos/IMG_1268.webp',
    original_path: './photos/IMG_1268.jpg',
    tags: ['Commission Portfolio'],
    time: ['2022', 'May', '16'],
    hv: false,
    rating: -1,
  },
  {
    alt: 'prom 2',
    src: './photos/IMG_1216.webp',
    original_path: './photos/IMG_1216.jpg',
    tags: ['Commission Portfolio'],
    time: ['2025', 'May', '16'],
    hv: true,
    rating: -1,
  },
  {
    alt: 'prom 3',
    src: './photos/IMG_1137.webp',
    original_path: './photos/IMG_1137.jpg',
    tags: ['Commission Portfolio'],
    time: ['2022', 'May', '16'],
    hv: false,
    rating: -1,
  },
  {
    alt: 'untitled',
    src: './photos/IMG_9604.webp',
    original_path: './photos/IMG_9604.jpg',
    tags: [],
    time: ['2021', 'Nov', '29'],
    hv: true,
    rating: -1,
  },
  {
    alt: 'concert',
    src: './photos/IMG_9064.webp',
    original_path: './photos/IMG_9064.jpg',
    tags: [],
    time: ['2021', 'Oct', '25'],
    hv: false,
    rating: -1,
  },
  {
    alt: 'tkd',
    src: './photos/DSC02765.webp',
    original_path: './photos/DSC02765.jpg',
    tags: ['Commission Portfolio'],
    time: ['2026', 'Mar', '24'],
    hv: true,
    rating: -1,
  },
  {
    alt: 'tkd2',
    src: './photos/DSC02836.webp',
    original_path: './photos/DSC02836.jpg',
    tags: ['Commission Portfolio'],
    time: ['2026', 'Mar', '24'],
    hv: true,
    rating: -1,
  },
  {
    alt: 'tkd3',
    src: './photos/DSC02801.webp',
    original_path: './photos/DSC02801.jpg',
    tags: ['Commission Portfolio'],
    time: ['2026', 'Mar', '24'],
    hv: false,
    rating: -1,
  },
  {
    alt: 'cinematic',
    src: './photos/DSC03161.webp',
    original_path: './photos/DSC03161.jpg',
    tags: ['Commission Portfolio'],
    time: ['2026', 'Apr', '18'],
    hv: false,
    rating: -1,
  },
  {
    alt: 'cheers',
    src: './photos/DSC03059_2.webp',
    original_path: './photos/DSC03059_2.jpg',
    tags: ['Commission Portfolio'],
    time: ['2026', 'Apr', '16'],
    hv: false,
    rating: -1,
  },
  {
    alt: 'cheers',
    src: './photos/DSC03110.webp',
    original_path: './photos/DSC03110.jpg',
    tags: ['Commission Portfolio'],
    time: ['2026', 'Apr', '16'],
    hv: false,
    rating: -1,
  },
  //add here
];
// change featured here
export let misc_tags = ['Commission Portfolio','All', 'Phone'];
export let other_collapsible_tags = [
  
  {
    name: 'Form',
    collapsed: true,
    tags: ['Street', 'Landscape', 'Protrait', 'Structure','Abstract'],
  },
  {
    name: 'Location',
    collapsed: true,
    tags: ['New York', 'Europe', 'San Francisco', 'Berkeley'],
  },
  {
    name: 'Subject',
    collapsed: true,
    tags: ['Human', 'Plants', 'Animal','Food'],
  },
  {
    name: 'Color',
    collapsed: true,
    tags: ['B&W', 'Green', 'Purple', 'Biege','Blue','Pink','Rainbow'],
  },
  {
    name:'Collections',
    collapsed:true,
    tags:['Birds of Shenzhen Bay', 'Shape of Light', 'Berkeley Botanical Garden', 'July 4th'],
  },
];
